import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from './button/button.component';
import { IconFontComponent } from './font/font.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { CommunitySectionComponent } from './community-section/community-section.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlaySectionComponent } from './why-huiospay-overlay-section/overlay-section.component';
import { DevelopersOverlaySectionComponent } from './developers-overlay-section/developers-overlay-section.component';
import { MapSectionComponent } from './map-section/map-section.component';
import { BusinessModelSectionComponent } from './business-model-section/business-model-section.component';
import { NewHeaderComponent } from './new-header/new-header.component';
import { NewFooterComponent } from './new-footer/new-footer.component';
import { PosMerchantModalComponent } from './pos-merchant-modal/pos-merchant-modal.component';

@NgModule({
  declarations: [
    ButtonComponent,
    IconFontComponent,
    NavbarComponent,
    FooterComponent,
    BackToTopComponent,
    CommunitySectionComponent,
    OverlaySectionComponent,
    DevelopersOverlaySectionComponent,
    MapSectionComponent,
    BusinessModelSectionComponent,
    NewHeaderComponent,
    NewFooterComponent,
    PosMerchantModalComponent,
  ],
  imports: [CommonModule, BrowserAnimationsModule, RouterModule, ReactiveFormsModule],
  exports: [
    ButtonComponent,
    IconFontComponent,
    NavbarComponent,
    FooterComponent,
    CommunitySectionComponent,
    OverlaySectionComponent,
    DevelopersOverlaySectionComponent,
    BackToTopComponent,
    MapSectionComponent,
    BusinessModelSectionComponent,
    NewHeaderComponent,
    NewFooterComponent,
    PosMerchantModalComponent,
  ],
})
export class ComponentsModule {}
